<template>
  <div class="container-fluid p-0">
    
    <div class="skip-links">
      <a href="#main-content" class="skip-link">Zum Hauptinhalt</a>
    </div>

    <div class="row justify-content-center g-0">
      <div class="col-md-6 col-lg-5 col-sm-12 p-0">
        <div class="card shadow mt-5 mx-3">
          <div class="card-body p-4">
            <h2 id="main-content" class="text-center mb-4">Passwort zurücksetzen</h2>
            
            <div v-if="isEmailSent" class="email-sent-container text-center">
              <div class="success-icon mb-3">
                <font-awesome-icon icon="envelope-circle-check" size="3x" class="text-success" />
              </div>
              <p>E-Mail wurde gesendet</p>
              <p class="email-display fw-bold mb-4">{{ email }}</p>
              <p class="small text-muted">Bitte überprüfe auch deinen Spam-Ordner</p>
              <button 
                @click="resetForm" 
                class="btn btn-outline-primary mt-3"
                :disabled="isResending"
              >
                {{ 'Link erneut senden' }}
              </button>
              <div class="mt-4">
                <router-link to="/auth/login" class="text-decoration-none">
                  {{ 'Passwort wieder eingefallen?' }}
                </router-link>
              </div>
            </div>

            <form v-else @submit.prevent="sendResetLink" novalidate>
              <p class="text-muted mb-4">Gib deine E-Mail-Adresse ein, um einen Link zum Zurücksetzen deines Passworts zu erhalten.</p>
              
              
              <div v-if="errorMessage" class="alert alert-danger" role="alert">
                {{ errorMessage }}
              </div>
              <div v-if="successMessage" class="alert alert-success" role="alert">
                {{ successMessage }}
              </div>
              
              <div class="mb-3">
                <label for="email" class="form-label">E-Mail</label>
                <div class="input-group">
                  <span class="input-group-text">
                    <font-awesome-icon icon="envelope" />
                  </span>
                  <input
                    v-model="email"
                    id="email"
                    type="email"
                    class="form-control"
                    :class="{ 'is-invalid': emailError }"
                    :placeholder="'E-Mail'"
                    required
                    autocomplete="email"
                    @invalid="onInvalidEmail"
                    @input="emailError = ''"
                  />
                </div>
                <div v-if="emailError" class="invalid-feedback d-block">
                  {{ emailError }}
                </div>
              </div>

              <div class="d-grid gap-2">
                <button type="submit" class="btn btn-primary" :disabled="loading" @click="handleForgotPassword">
                  <span
                    v-if="loading"
                    class="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  {{ loading ? 'Wird gesendet...' : 'Link senden' }}
                </button>
                <router-link to="/auth/login" class="btn btn-outline-secondary">
                  {{ 'Zurück zur Anmeldung' }}
                </router-link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { forgotPassword } from '@/api/auth'

const email = ref('')
const isLoading = ref(false)
const errorMessage = ref('')
const successMessage = ref('')
const emailSent = ref(false)


const handleForgotPassword = async () => {
  if (!email.value.trim()) {
    errorMessage.value = 'Bitte gib deine E-Mail-Adresse ein.'
    return
  }

  try {
    isLoading.value = true
    errorMessage.value = ''
    successMessage.value = ''
    const response = await forgotPassword(email.value)
    emailSent.value = true
    successMessage.value = response.message
  } catch (error) {
    errorMessage.value = error?.response?.data?.message || error.message || 'Anfrage fehlgeschlagen'
    console.error('Anfrage fehlgeschlagen:', error)
  } finally {
    isLoading.value = false
  }
}
</script>
